import { render, staticRenderFns } from "./Sharing.vue?vue&type=template&id=a538389c&scoped=true&"
import script from "./Sharing.vue?vue&type=script&lang=js&"
export * from "./Sharing.vue?vue&type=script&lang=js&"
import style0 from "./Sharing.vue?vue&type=style&index=0&id=a538389c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a538389c",
  null
  
)

export default component.exports